import React from 'react';
import { useParams } from 'react-router-dom';

const TermsPage: React.FC = () => {
  const { serviceKey } = useParams<{ serviceKey: string }>();
  return (
    <main className="max-w-2xl mx-auto py-10 px-4 text-foreground">
      <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
      <p className="mb-4">Welcome to {serviceKey ? serviceKey : 'our service'}! Please read these Terms of Service carefully before using our platform.</p>
      <ul className="list-disc pl-6 space-y-2 mb-4">
        <li>By using our service, you agree to comply with all applicable laws and regulations.</li>
        <li>Your use of the platform is at your own risk. We are not liable for any damages or losses.</li>
        <li>Do not misuse the service or attempt to access it using a method other than the interface and instructions we provide.</li>
        <li>We reserve the right to suspend or terminate your access if you violate these terms.</li>
        <li>We may update these terms from time to time. Continued use of the service means you accept the new terms.</li>
      </ul>
      <p>For questions, please contact support@{serviceKey ? serviceKey : 'ourservice'}.com.</p>
    </main>
  );
};

export default TermsPage;
